import { createFileRoute } from "@tanstack/react-router"

import { GuidePage } from "../components/landing"
import { gstGuide } from "../content/gst-calculator"
import { guideSeo } from "./guides.$slug"

const PATH = "/gst-calculator"

/** Free GST calculator (T915); the content is a `Guide`, the URL is top level like /cents-per-km-calculator. */
export const gstCalculatorSeo = () => guideSeo(gstGuide, PATH)

export const Route = createFileRoute("/_brand-layout/gst-calculator")({
  head: () => {
    const { meta, links, scripts } = gstCalculatorSeo()
    return { meta, links, scripts }
  },
  component: () => <GuidePage guide={gstGuide} />,
})
